import { combineReducers } from 'redux'
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import routerReducer, { routerHistoryMiddleware } from './routerReducer'
import persistReducer from 'redux-persist/es/persistReducer'

import { api } from 'app/services/api'
import searchSlice from 'app/search/searchSlice'
import resultsSlice from 'app/results/resultsSlice'
import settingsSlice from './settings/settingsSlice'
import { getTaxonomyReducers } from './taxonomies/taxSlices'

const searchPersistConfig = {
  key: 'search',
  version: 1,
  storage,
  whitelist: [
    // List of searchState properties to persist in cache
  ],
}

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  [settingsSlice.name]: settingsSlice.reducer,
  [searchSlice.name]: persistReducer(searchPersistConfig, searchSlice.reducer),
  [resultsSlice.name]: resultsSlice.reducer,
  ...getTaxonomyReducers(),
  router: routerReducer,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(api.middleware)
      .concat(routerHistoryMiddleware),
})

setupListeners(store.dispatch)

export type AppThunkOptions<RejectValue = string> = {
  rejectValue: RejectValue
  state: RootState
}
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
